// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"TruncatedNote-primaryButton-jeU5X2","truncated":"TruncatedNote-truncated-Tw52SR"};